export default "__VITE_ASSET__DOWBrgaa__"